import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/** The path of each form list the project overview reads. */
export const FORM_ATTENTION_PATHS = {
  nonConformance: 'non-conformance-reports',
  trMeters: 'tr-meters',
};

/**
 * The project's non-conformance reports that are unprocessed or done today
 * (`kind` 'nonConformance'), or its TR meters with deficiencies to fix or
 * done today ('trMeters'): GET projects/{projectId}/{path}/attention, today
 * being `dayStart`..`dayEnd`, the user's local day as ISO timestamps. The
 * backend checks forms access and the form type's own access permission.
 */
export const getProjectFormAttention = async ({
  projectId,
  kind,
  dayStart,
  dayEnd,
}) => {
  const apiPath = `projects/${projectId}/${
    FORM_ATTENTION_PATHS[kind]
  }/attention?dayStart=${encodeURIComponent(
    dayStart
  )}&dayEnd=${encodeURIComponent(dayEnd)}`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
